import React from "react";
function Login(props) {
  return (
    <div className="bg-indigo-500 min-h-screen  w-full overflow-x-hidden flex flex-col">
      <div className="flex flex-col px-10 m-auto w-full mt-auto">
        {props.children}
      </div>

      {/* copyright */}
      <div className="mt-auto flex bottom-3 text-white w-full">
        <p className="text-xs m-auto mt-0 py-2 text-white">
          © Copyright AFODA {new Date().getFullYear()}. All rights reserved
        </p>
      </div>
    </div>
  );
}

export default Login;
